import { SWReactIcons } from "@similarweb/icons";
import { colorsPalettes } from "@similarweb/styles";
import styled from "styled-components";

export const WidgetContainer = styled.div`
    display: flex;
    flex-direction: column;
    height: 100%;
`;

export const WidgetHeaderContainer = styled.div`
    height: 84px;
    border-bottom: 1px solid ${colorsPalettes.carbon["50"]};
    display: flex;
    flex-direction: column;
    padding-left: 24px;
`;

export const WidgetContentContainer = styled.div`
    padding-left: 24px;
    padding-right: 20px;
    height: 100%;
`;

export const WidgetFooterContainer = styled.div`
    height: 51px;
    border-top: 1px solid ${colorsPalettes.carbon["50"]};
    padding-right: 24px;
    padding-left: 24px;
    display: flex;
    flex-direction: row-reverse;
    flex-shrink: 0;
    align-items: center;
`;

export const TitleContainer = styled.div`
    margin: 20px 0 4px 0;
    display: flex;
    flex-direction: row;
    height: 20px;
`;

export const Header = styled.div`
    font-size: 20px;
    color: ${colorsPalettes.carbon["500"]};
    margin-right: 4px;
    font-weight: 500;
`;

export const SubTitleContainer = styled.div`
    margin-bottom: 20px;

    div {
        font-size: 13px;
    }
`;

export const MetricsContainer = styled.div`
    display: flex;
    flex-direction: row;
    height: 100%;
    justify-content: space-between;
`;

export const MetricContainer = styled.div`
    display: flex;
    flex-direction: row;
    height: 40px;
    justify-content: space-between;
    align-items: center;
`;

export const MetricLeftSide = styled.div`
    display: flex;
    flex-direction: row;
    margin-right: 16px;
    align-items: center;
`;

export const MetricIcon = styled(SWReactIcons)`
    width: 24px;
    height: 24px;
    margin-right: 16px;
`;

export const MetricName = styled.div`
    font-size: 14px;
    margin-right: 6px;
`;

export const MetricValue = styled.div`
    font-size: 24px;
    margin-right: 3px;
`;

export const TooltipIcon = styled(SWReactIcons)`
    height: 16px;
    width: 16px;
`;

export const MetricsColumn = styled.div.attrs<{ width?: string }>((props) => ({
    width: props.width || "30%",
}))<{ width?: string }>`
    display: flex;
    flex-direction: column;
    justify-content: space-evenly;
    min-width: ${(props) => props.width};
`;

export const MetricValueContainer = styled.div`
    display: flex;
`;
